import * as _ from "underscore";
import { REPORT_NAMES } from "./enum";

export const generateTableStructure=(jsonData,performance)=>{
    let data =[]
    
    if(performance === REPORT_NAMES.PERFORMANCE){
        data.push({
            "Output": _.pluck(jsonData, "output"),
            "Rated Output": _.pluck(jsonData, "capacity"),
            "Performance %": _.pluck(jsonData, "performance")
        });
        
        return data;

    } else if (performance === REPORT_NAMES.ACHIEVEMENT){
        const achievements = _.pluck(jsonData, performance);

        data.push({
            "Actual output": _.pluck(achievements, "output"),
            "Extended output": _.pluck(achievements, "targetOutput"),
            "Achievement %":_.pluck(achievements, "achievement")
        });

        return data;

    } else if (performance === REPORT_NAMES.DOWNTIME){
        data.push({
            "Production Time": _.pluck(jsonData, "productionTime"),
            "Down Time": _.pluck(jsonData, "downtime"),
        });
        
        return data;

    } else if (performance === REPORT_NAMES.OEE){
        const oee = _.pluck(jsonData, performance);

        data.push({
            "Availability":_.pluck(oee, "availability"),
            "Performance":_.pluck(oee, "performance"),
            "Quality": _.pluck(oee, "quality"),
            "OEE %": _.pluck(oee, "oee")
        });
        
        return data;
    } else if (performance === REPORT_NAMES.AVERAGE_ORDER_SIZE){
        let colorsData = [];
        let orderSizeData = [];
        let lengthData = [];

        orderSizeData.push({
            "Total Output": _.pluck(jsonData, "totalOutput"),
            "No. of Jobs": _.pluck(jsonData, "noOfJobs"),
            "Average Order Size": _.pluck(jsonData, "averageOrderSize"),
        });

        /** ---Colors data in average order size--- */
        const colors = _.pluck(jsonData, "noOfColorsAndJobs");
        const colorsKeys =[];
        let colorsObject={};

        colors.map((r) => {
            Object.keys(r).map((k) => {
                colorsKeys.includes(k)===false && colorsKeys.push(k);
            })
        })

        colorsKeys.map((k) => {
            colorsObject = { ...colorsObject, [k]:_.pluck(colors, k).map(value => value || 0)};
        });

        colorsData.push({ ...colorsObject});

        /** ---Job length data in average order size--- */
        const length = _.pluck(jsonData, "lengthAndNoOfJobs");
        const lengthKeys = [];
        let lengthObject={};

        length.map((r) => {
            Object.keys(r).map((k) => {
                lengthKeys.includes(k)===false && lengthKeys.push(k);
            });
        });

        lengthKeys.map((k) => {
            lengthObject = { ...lengthObject, [k]:_.pluck(length, k).map(value => value || 0)};
        });

        lengthData.push({...lengthObject});

        data.push(
            orderSizeData,
            colorsData,
            lengthData
        );

        return data;
    } else if (performance === REPORT_NAMES.WASTAGE){
        data.push({
            "Output":_.pluck(jsonData, "output"),
            "Target Wastage":_.pluck(jsonData, "targetWastage"),
            "Actual Wastage": _.pluck(jsonData, "actualWastage"),
            "Wastage %": _.pluck(jsonData, "wastage")
        });
        
        return data;
    } else if (performance === REPORT_NAMES.UTILIZATION){
        const machineUtil = _.pluck(jsonData,"machineUtilization");

        data.push({
            "Capacity Utilized %":_.pluck(machineUtil, "utilizedCapacity"),
            "Time Utilized %":_.pluck(machineUtil, "time"),
            "Lost Capacity": _.pluck(machineUtil, "lostCapacity"),
        });
        
        return data;
    } else {
        return data;
    }
}